module.exports = __webpack_public_path__ + "img/2@2x.ea15019e.png";